import { render, staticRenderFns } from "./PS-results.vue?vue&type=template&id=716b20ed"
import script from "./PS-results.vue?vue&type=script&lang=js"
export * from "./PS-results.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports